import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { ServicesGrid } from '../components/ServicesGrid';
import { AboutSection } from '../components/AboutSection';
import { ProcessSection } from '../components/ProcessSection';
import { PortfolioGallery } from '../components/PortfolioGallery';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ServiceAreasSection } from '../components/ServiceAreasSection';
import { FAQSection } from '../components/FAQSection';
import { CTABanner } from '../components/CTABanner';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="min-h-screen w-full font-sans selection:bg-[var(--brand-gold)] selection:text-black" data-id="element-219">
      <Header data-id="element-220" />
      <HeroSection data-id="element-221" />
      <TrustBar data-id="element-222" />
      <ServicesGrid data-id="element-223" />
      <AboutSection data-id="element-224" />
      <ProcessSection data-id="element-225" />
      <PortfolioGallery data-id="element-226" />
      <TestimonialsSection data-id="element-227" />
      <ServiceAreasSection data-id="element-228" />
      <FAQSection data-id="element-229" />
      <CTABanner data-id="element-230" />
      <Footer data-id="element-231" />
    </main>;
}